module.exports = __webpack_public_path__ + "static/media/destadskoerier.278c19c9.png";